// @noflow
export function drawLine(context, from, to, lineWidth = 1, strokeStyle = '#000000') {
    context.beginPath();
    context.lineWidth = lineWidth;
    context.strokeStyle = strokeStyle;
    context.moveTo(from.x, from.y);
    context.lineTo(to.x, to.y);
    context.stroke();
    context.closePath();

    return context;
}

export const drawCircle = (context, properties) => {
    const { x, y, radius, ...rest } = properties;
    context.beginPath();
    context.arc(x, y, radius, 0, Math.PI * 2);

    for (const prop in rest) {
        if ({}.hasOwnProperty.call(rest, prop)) {
            context[prop] = rest[prop];
        }
    }

    context.fill();
    context.stroke();
    context.closePath();

    for (const prop in rest) {
        if ({}.hasOwnProperty.call(rest, prop)) {
            context[prop] = null;
        }
    }

    return context;
};



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/rgb-flipper/color-picker/canvas-helpers.js